import { Language } from "../core";

export type StringKey =
  | "title"
  | "subTitle"
  | "introduction"
  | "openInfoModal"
  | "introDescription"
  | "appDescription"
  | "eventDescription"
  | "closeInfoModal"
  | "waitingForMic"
  | "micError"
  | "sendingError"
  | "lessonComplete"
  | "thankYou"
  | "hearMore"
  | "recordButton"
  | "startingButton"
  | "doneButton"
  | "sendButton"
  | "discardButton";

type LanguageStrings = { [S in StringKey]: string };

const fiStrings: LanguageStrings = {
  title: "Robottikuoro",
  subTitle: "Opeta robotit laulamaan!",
  introduction:
    "Paina allaolevaa painiketta ja laula tai ääntele roboteille. Antamasi ääni kuullaan Robottikuoron esityksessä Helsingin juhlaviikoilla.",
  openInfoModal: "Kerro lisää",
  closeInfoModal: "Takaisin",
  introDescription:
    "Robottikuoro on ääni-installaatio, jonka ovat toteuttaneet <a href='https://ctpt.co/'>Counterpoint</a> ja <a href='https://www.tyttiarola.com/'>Tytti Arola</a>. Se koostuu kymmenistä erilaisista kaiuttimista ja laajentaa kuorosointia uusiin, ihmisäänelle mahdottomiin ulottuvuuksin.",
  appDescription:
    "Tällä sovelluksella voit opettaa Robottikuoroa laulamaan. Anna äänesi kuorolle, ja se oppii laulamaan niin kuin sinä laulat. Ääntäsi tullaan käyttämään Robottikuoron esityksissä.",
  eventDescription:
    "Robottikuoron <a href='https://helsinkifestival.fi/ohjelma/robottikuoro/'>ensiesiintyminen</a> tapahtuu Taiteiden Yönä, osana <a href='https://helsinkifestival.fi/'>Helsingin juhlaviikkoja</a>.",
  waitingForMic: "Odotetaan mikrofonia&hellip;",
  micError:
    "Emme löytäneet mikfofonia. Annathan luvan pyydettäessä. Tarvittaessa voit kokeilla toisella laitteella.",
  sendingError:
    "Pahoittelemme, äänen lähetys ei onnistunut. Yritäthän uudelleen!",
  lessonComplete: "Koulutus {} tehty.",
  thankYou: "Kiitos!",
  hearMore:
    "Tulethan kuuntelemaan Robottikuoroa Senaatintorille 15.8.<br>Kouluta halutessasi robotteja uudelleen!",
  recordButton: "Nauhoita",
  doneButton: "Pysäytä",
  startingButton: "Aloitetaan",
  sendButton: "Lähetä",
  discardButton: "Nauhoita uudelleen"
};

const enStrings: LanguageStrings = {
  title: "The Robot Choir",
  subTitle: "Teach the robots to sing!",
  introduction:
    "Click the button below, then sing or babble to the Robot Choir. Your sound will be incorporated in to their performance at the Helsinki Festival.",
  openInfoModal: "Tell me more",
  closeInfoModal: "Back",
  introDescription:
    "The Robot Choir is a sound installation realised by <a href='https://ctpt.co/'>Counterpoint</a> and <a href='https://www.tyttiarola.com/'>Tytti Arola</a>. It consists of tens of different speakers that extend the choir sound to new dimensions that are impossible for the human voice.",
  appDescription:
    "With this app you can teach the Robot Choir to sing. Give your voice to the choir and it'll learn how to sing like you do. Your voice will then be incorporated to the Robot Choir's performance.",
  eventDescription:
    "The Robot Choir's <a href='https://helsinkifestival.fi/en/programme/robot-choir/'>inaugural performance</a> will take place on The Night of The Arts, as part of <a href='https://helsinkifestival.fi/en/'>Helsinki Festival 2019</a>.",
  waitingForMic: "Waiting for microphone access&hellip;",
  micError:
    "Could not get microphone access. Please give us permission when prompted, or try another device.",
  sendingError:
    "Sorry, something went wrong when sending the sound. Please try again!",
  lessonComplete: "Lesson {} complete.",
  thankYou: "Thank you!",
  hearMore:
    "Come hear the Robot Choir perform on the Helsinki Senate Square August 15.<br>And if you'd like, teach the robots some more!",
  recordButton: "Record",
  doneButton: "Stop",
  startingButton: "Starting",
  sendButton: "Send",
  discardButton: "Record again"
};

export function getString(language: Language, key: StringKey) {
  let strings = language === "english" ? enStrings : fiStrings;
  return strings[key];
}

export function getDefaultLanguage(): Language {
  let storedLang = window.localStorage.getItem("defaultLanguage");
  if (storedLang) {
    return storedLang as Language;
  } else {
    let nativeLang = navigator.language.toLocaleLowerCase();
    return nativeLang === "fi" || nativeLang === "fi-fi" ? "suomi" : "english";
  }
}

export function setDefaultLanguage(lang: Language) {
  window.localStorage.setItem("defaultLanguage", lang);
}
